export enum ChatRecordType {
  Call = 'Calls',
  Conversation = 'Conversations',
  Message = 'Messages',
  Preference = 'Preferences',
  Shared_In = 'Shared-In',
  Shared_Out = 'Shared-Out',
  Trash = 'Trash',
  Deleted = 'deleted',
}

export enum CallRecordType {
  Channel = 'Channel',
  Direct = 'DirectMessage',
  Calendar = 'Calendar',
}
export enum ConversationScopes {
  Direct = 'Direct',
  Channel = 'Channel',
  Call = 'Call',
  Thread = 'Thread',
  Calender = 'Calender',
  All = 'All',
}
export enum ConversationTypes {
  Direct = 'Direct',
  Channel = 'Channel',
  All = 'All',
}
export enum ConversationPreferenceVisibility {
  Visible = 'Visible',
  Hidden = 'Hidden',
  Starred = 'Starred',
}
export enum ConversationNotification {
  Off = 'Off',
  All = 'All',
  Mentions = 'Mentions',
}
export enum RecordAccessibility {
  Accessible = 'Accessible',
  InAccessible = 'InAccessible',
  Both = 'Both',
}

export enum MessageType {
  All = 'All',
  Regular = 'Regular',
  System = 'System',
  BreakOut = 'BreakOut',
  Transcript = 'Transcript',
}
export enum ConversationVisibility {
  Public = 'Public',
  Private = 'Private',
}

export enum MessagesListFilterNames {
  Accessibility = 'accessibilities',
  MessageType = 'messageTypes',
}
export enum SystemConnectionAction {
  ADDED = 'Added',
  REMOVED = 'Removed',
}

export enum SystemMessageNotificationType {
  CallNotifier = 'Call Notifier',
  AccessNotifier = 'Access Notifier',
}
export enum ConversationSyncStatus {
  Host = 'Host',
  SyncingAll = 'Syncing All',
  SyncingPartial = 'Syncing Partial',
  SyncingEnded = 'Syncing Ended',
}

export enum ConversationMemberAccessStatus {
  FutureAccess = 'Future Access',
  PastAccess = 'Past Access',
  FullAccess = 'Full Access',
  NoAccess = 'No Access',
  LimitedAccess = 'Limited Access',
}
export enum ConsentStatus {
  Accepted = 'Accepted',
  Ignored = 'Ignored',
  Pending = 'Pending',
}

export enum ConversationParticipantTypes {
  member = 'Member',
  connection = 'Connection',
}

export enum ConversationMemberAccessActions {
  Grant = 'Grant',
  Revoke = 'Revoke',
}

export enum UnReadBadgeResponse {
  Enabled = 'Enabled',
  Muted = 'Muted',
}

export enum MessageRecordModuleType {
  File = 'file',
  Interview = 'interview',
  Contact = 'contact',
  WorkerProfile = 'workerProfile',
  Jobs = 'jobs',
  Chat = 'Chat',
}

export enum CallType {
  STARTED = 'started',
  ENDED = 'ended',
}

export enum DMConversationDisplayMode {
  Selection = 'Select',
  Creation = 'Create',
}

export enum MemberConnectionOptions {
  Personal = 'Personal',
  Other = 'Other',
  Connection = 'Connection',
}

export enum ChatShareRecordType {
  Conversation = 'conversation',
  Message = 'message',
  Connection = 'connection',
  Member = 'member',
}
